import {mapState, mapMutations, mapActions, mapGetters} from 'vuex'
import {getInstitutionSorlList} from '../../request/index/organization'
import {getToken} from '../../request/common'

export default {
    namespaced: true,
    state: {
        // 上市企业列表
        listToken: '',
        listKeyWord: '',
        pageNum: 1,
        listData: {},
        listHasUrlParam: false,
        listHasContent: false,
        listDataSate: true
    },
    mutations: {
        setList (state, payLoad) {
            state.keyWord = payLoad.kw
            state.pageNum = payLoad.pageNum
            state.listData = payLoad.data
        },
        setListKeyWord (state, kw) {
            state.listKeyWord = kw
        },
        setToken (state, token) {
            state.listToken = token
        },
        setListHasUrlParam (state, isOpen) {
            state.listHasUrlParam = isOpen
        },
        setListHasContent (state, isOpen) {
            state.listHasContent = isOpen
        },
        setListDataSate (state, isOpen) {
            state.listDataSate = isOpen
        }
    },
    actions: {
        // payLoad: kw, page
        getList (context, payLoad) {
            // 获取参数
            let organizationSearchParams = {
                param: {keyword: payLoad.kw, page: payLoad.page},
                token: payLoad.token
            }
            // 请求接口
            return getInstitutionSorlList(organizationSearchParams.param, organizationSearchParams.token).then(res => {
                if (parseInt(res.code) === 103001) {
                    window.location.href = res.data.jumpUrl
                } else if (parseInt(res.code) === 100000) {
                    // 将列表信息和搜索值传入store (这个接口就算返回值是空格式也是正确的,载荷为res.data与searchKw)
                    const payLoad = {
                        kw: organizationSearchParams.param.keyword,
                        pageNum: organizationSearchParams.param.page,
                        data: res.data
                    }
                    if (res.data.data && res.data.data.length > 0) {
                        context.commit('setListDataSate', true)
                    } else {
                        context.commit('setListDataSate', false)
                    }
                    context.commit('setList', payLoad)
                } else {
                    context.commit('setListDataSate', false)
                    console.warn('获取机构列表失败')
                }
                return res
            })
        },
        getToken (context) {
            return getToken().then(res => {
                if (res.success) {
                    context.commit('setToken', res.data)
                }
                return res
            })
        }
    },
    getters: {}
}



// WEBPACK FOOTER //
// ./src/store/modules/organization.js